"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _locales = require("../utils/locales");

var _index = require("../utils/index");

var _cookie = require("../utils/cookie");

var _checkReminder = _interopRequireDefault(require("../utils/checkReminder"));

var _iconShare = _interopRequireDefault(require("./iconShare"));

var _iconAdd = _interopRequireDefault(require("./iconAdd"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SwipeableDrawer = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: "swipeableDrawer" */
  "@material-ui/core/SwipeableDrawer");
});
var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$typography, _theme$typography2, _theme$palette2;

  return {
    root: {
      background: theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main,
      position: "relative"
    },
    bar: {
      backgroundColor: "#FFFFFF",
      borderRadius: 10,
      cursor: "move",
      height: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(1.5, "auto", 0, "auto"),
      width: theme === null || theme === void 0 ? void 0 : theme.spacing(8)
    },
    container: {
      color: "#FFFFFF",
      display: "flex",
      flexDirection: "column",
      height: "80vh",
      margin: "0 auto",
      maxHeight: 340,
      maxWidth: 420,
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(4, 2)
    },
    headline: {
      fontSize: 18,
      fontWeight: theme === null || theme === void 0 ? void 0 : (_theme$typography = theme.typography) === null || _theme$typography === void 0 ? void 0 : _theme$typography.fontWeightBold,
      marginBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(4),
      textTransform: "uppercase"
    },
    box: {
      alignItems: "center",
      display: "flex",
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(2, 0)
    },
    step: {
      fontSize: 36,
      fontWeight: theme === null || theme === void 0 ? void 0 : (_theme$typography2 = theme.typography) === null || _theme$typography2 === void 0 ? void 0 : _theme$typography2.fontWeightLight
    },
    text: {
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(0, 2)
    },
    icon: {
      alignItems: "center",
      background: "#FFFFFF",
      borderRadius: 4,
      display: "flex",
      flex: "0 0 " + (theme === null || theme === void 0 ? void 0 : theme.spacing(5)) + "px",
      fill: theme === null || theme === void 0 ? void 0 : (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.grey[900],
      height: theme === null || theme === void 0 ? void 0 : theme.spacing(5),
      justifyContent: "center",
      marginLeft: "auto",
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
      width: theme === null || theme === void 0 ? void 0 : theme.spacing(5),
      "& svg": {
        height: theme === null || theme === void 0 ? void 0 : theme.spacing(4),
        width: theme === null || theme === void 0 ? void 0 : theme.spacing(4)
      }
    },
    iconApp: {
      background: "none",
      padding: 0
    },
    app: {
      borderRadius: 4,
      display: "block",
      width: "100%"
    }
  };
});

var ReactPwaAlert = function ReactPwaAlert(_ref) {
  var appIcon = _ref.appIcon,
      _ref$checkCookie = _ref.checkCookie,
      checkCookie = _ref$checkCookie === void 0 ? true : _ref$checkCookie,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug,
      _ref$force = _ref.force,
      force = _ref$force === void 0 ? false : _ref$force,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "de" : _ref$lang,
      _ref$reminder = _ref.reminder,
      reminder = _ref$reminder === void 0 ? 365 : _ref$reminder;
  var css = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  if (lang !== "de") {
    lang = "de";
  }

  if (debug) {
    var x = [];
    x.push("isIOS: " + (0, _index.isIOS)());
    x.push("isInStandaloneMode: " + (0, _index.isInStandaloneMode)());
    x.push("isIOSChrome: " + (0, _index.isIOSChrome)());
    x.push("isIOSEdge: " + (0, _index.isIOSEdge)());
    x.push("react-pwa-alert storage: " + (localStorage.getItem("react-pwa-alert") !== null));

    if (checkCookie) {
      x.push("mw-cookie-settings is not empty: " + ((0, _cookie.getCookie)("mw-cookie-settings") !== ""));
    }

    alert(x.join("\r\n"));
  }

  (0, _react.useEffect)(function () {
    if (show(checkCookie, force, reminder)) {
      setTimeout(function () {
        setOpen(true);
        localStorage.setItem("react-pwa-alert", new Date());
      }, force ? 300 : 3000);
    }
  }, [checkCookie, force, reminder]);
  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (!show(checkCookie, force, reminder)) return null;
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, /*#__PURE__*/_react.default.createElement(SwipeableDrawer, {
    anchor: "bottom",
    disableBackdropTransition: !iOS,
    disableDiscovery: iOS,
    disableSwipeToOpen: true,
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    onOpen: function onOpen() {}
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.root, "pwa-alert")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.bar, "pwa-alert__bar")
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.container, "pwa-alert__container")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "pwa-alert__content")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.headline, "pwa-alert__headline")
  }, /*#__PURE__*/_react.default.createElement("span", null, _locales.locales[lang].headline)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.box, "pwa-alert__box pwa-alert__box1")
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _clsx.default)(css.step, "pwa-alert__step")
  }, "1"), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _clsx.default)(css.text, "pwa-alert__text")
  }, _locales.locales[lang].step1), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.icon, "pwa-alert__icon", "pwa-alert__icon-share")
  }, /*#__PURE__*/_react.default.createElement(_iconShare.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.box, "pwa-alert__box pwa-alert__box2")
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _clsx.default)(css.step, "pwa-alert__step")
  }, "2"), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _clsx.default)(css.text, "pwa-alert__text")
  }, _locales.locales[lang].step2), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.icon, "pwa-alert__icon", "pwa-alert__icon-add-to-home")
  }, /*#__PURE__*/_react.default.createElement(_iconAdd.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.box, "pwa-alert__box pwa-alert__box3")
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _clsx.default)(css.step, "pwa-alert__step")
  }, "3"), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _clsx.default)(css.text, "pwa-alert__text")
  }, _locales.locales[lang].step3), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.icon, css.iconApp, "pwa-alert__icon", "pwa-alert__icon-app")
  }, appIcon && /*#__PURE__*/_react.default.createElement("img", {
    className: css.app,
    src: appIcon,
    alt: ""
  }))))))));
};

var show = function show(checkCookie, force, reminder) {
  return force || (0, _index.isIOS)() && !(0, _index.isInStandaloneMode)() && !(0, _index.isIOSChrome)() && !(0, _index.isIOSEdge)() && (0, _checkReminder.default)(reminder) && (checkCookie ? (0, _cookie.getCookie)("mw-cookie-settings") !== "" : true);
};

ReactPwaAlert.propTypes = {
  appIcon: _propTypes.default.string,
  checkCookie: _propTypes.default.bool,
  debug: _propTypes.default.bool,
  force: _propTypes.default.bool,
  lang: _propTypes.default.string,
  reminder: _propTypes.default.number
};
var _default = ReactPwaAlert;
exports.default = _default;